<template>
	<div class="totalinfo">
	     <a-tag color="blue" style="text-align:left">
            <span  style="font-size:15px;padding:5px;display:inline-block">
		      <strong>全部：</strong>
		      总金额：{{ sum.yuzhi }} 元,
		      已拨款：{{ sum.yibokuan }} 元,
		      未拨款：{{ sum.weibokuan }} 元,
		      发放总金额：{{ sum.lingqu }} 元
		  </span>
	     </a-tag>
	     <a-tag color="blue" style="text-align:left">
            <span  style="font-size:15px;padding:5px;display:inline-block">
		      <strong>本页：</strong>	
		      总金额：{{ psum.yuzhi }} 元,
		      已拨款：{{ psum.yibokuan }} 元,
		      未拨款：{{ psum.weibokuan }} 元,
		      发放总金额：{{ psum.lingqu }} 元
		  </span>
	     </a-tag>
	   </div>
</template>
<script>
export default {
	props:["sum","psum"]
}
</script>
<style scoped>
.totalinfo{
		margin: 0px 0px 10px 0px;
		display: flex;
		justify-content: flex-start;
	}
</style>


